"use client";

import type { YnsComponentForm } from "../types";
import type { Newsletter } from "./newsletter";

export const NewsletterForm: YnsComponentForm<typeof Newsletter> = ({ data }) => {
	return <div className="grid gap-4 relative pb-20">Form</div>;
};
